<template>
  <div class="navBar">
    <Notification class="header-tool" />
    <UserAbility class="header-tool user-ability" />
  </div>
</template>

<script>
import { Notification, UserAbility } from '@/components/business/header-tools/index'

export default {
  name: 'NavBar',
  components: { Notification, UserAbility }
}
</script>

<style lang="scss" scoped>
  .navBar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 24px;
    height:100%;
  }

  .header-tool {
    flex-shrink:0;
    width:42px;
    display:inline-block;
    margin-right: 33px;

    &:last-child {
      margin-right: 0;
    }
    &.user-ability{
      width: auto;
    }
  }

</style>
